import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  maxlength?: number;
  status?: "" | "error" | "warning";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "Số nhà, tên đường..." },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    maxlength: { default: 255 },
    status: { default: "" }
  },
  emits: ["update:modelValue", "change", "blur", "pressEnter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onBlur = (e: FocusEvent) => emit("blur", e);
const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    maxlength: _ctx.maxlength,
    status: _ctx.status,
    class: "ant-address-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, {
    prefix: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["value", "placeholder", "disabled", "size", "allow-clear", "maxlength", "status"]))
}
}

})